import { render } from "./PriceForm.vue?vue&type=template&id=70f54d1a&scoped=true&ts=true"
import script from "./PriceForm.vue?vue&type=script&lang=ts"
export * from "./PriceForm.vue?vue&type=script&lang=ts"

import "./PriceForm.vue?vue&type=style&index=0&id=70f54d1a&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f54d1a"]])

export default __exports__